import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../../app/store";
import GrossSalaryIcon from "../../../assets/images/gross-salry-icon.svg";
import CustomModal from "../../../components/ui/CustomModal";
import { setShowModal } from "../../../features/auth/authSlice";
import { ModalComponentProps } from "../../../types";

type Props = {
  loading: boolean;
} & ModalComponentProps;

export default function GrossConfiguredYetModal({
  handleClose,
  ...rest
}: Props) {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return (
    <>
      <CustomModal
        // title="Download Report"
        {...rest}
        handleClose={handleClose}
        //   width={800}
        footer={null}
      >
        <div>
          <div className="flex justify-center items-center mt-4 mb-4">
            <img
              src={GrossSalaryIcon}
              alt="pdf_file_icon"
              className="w-[100px] h-[100px]"
            />
          </div>

          <div className="flex justify-center items-center mt-4 mb-4 font-bold text-xl">
            <h4>Gross Salary Not Configured Yet!</h4>
          </div>

          <div className="flex justify-center items-center mt-2 mb-2 font-normal text-slate-500">
            Looks like you forgot to configure gross salaries of some employees.
          </div>

          <div className="flex justify-center items-center gap-4 mt-4 mb-4">
            <Button
              className="normal-dark-button modal-button"
              onClick={handleClose}
              size="middle"
            >
              Skip
            </Button>
            <Button
              className="modal-button"
              type="primary"
              htmlType="submit"
              size="middle"
              onClick={() => {
                dispatch(setShowModal(false));
                navigate(`/admin/employees`);
              }}
            >
              Configure Now
            </Button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
